import { getUser } from "../auth";
import { APP_CONFIG } from "../types";

const appConfigSync = async (dispatch) => {
  return await getUser(dispatch);
};

export const appConfigAction = () => (dispatch) => {
  return appConfigSync(dispatch)
    .then(({ logo }) => {
      dispatch({ type: APP_CONFIG, payload: {} });
    })
    .catch((e) => {
      console.error(e);
    });
};
